import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../styles/TripDetails.scss";
import { Card } from "../components/common/Card";
import { FaBus, FaChair, FaFileAlt, FaUsers } from "react-icons/fa";

import { useState } from "react";
import { useAtomValue } from "jotai";
import { tripAtom } from "../components/JotaiStates/commonStateAtoms";
import useLogin from "../components/common/useLogin";

const TripDetails = () => {
  const navigate = useNavigate();
  const trip = useAtomValue(tripAtom);
  const { login } = useLogin();
  const { IsAllowBusSchedule, IsAllowpassengerboarding, IsViewTripSheet } = {
    ...login,
  };
  const schedule = {
    label: "Bus Schedule",
    icon: <FaBus />,
    path: "/bus-schedule",
  };
  const sheet = {
    label: "View Trip Sheet",
    icon: <FaFileAlt />,
    path: "/trip-sheet",
  };
  const boarding = {
    label: "Passenger Boarding",
    icon: <FaUsers />,
    path: "/passenger-boarding",
  };
  const chart = {
    label: "View Chart",
    icon: <FaChair />,
    path: "/view-chart",
  };
  const options = [];
  if (IsAllowBusSchedule) {
    options.push(schedule);
  }
  if (IsViewTripSheet) {
    options.push(sheet);
  }
  if (IsAllowpassengerboarding) {
    options.push(boarding);
  }
  options.push(chart);

  const [selectedOption, setSelectedOption] = useState(-1);

  if (!trip) {
    return <div>No Trip Data Found</div>;
  }
  const handleOptionClick = (index, path) => {
    setSelectedOption(index);
    navigate(path);
  };
  return (
    <div className="trip-details-container">
      {/* Header */}
      <div className="trip-details-header">
        <FaArrowLeft className="back-icon" onClick={() => navigate(-1)} />
        <div>
          <div className="route-text">{trip.RouteName}</div>
          <div className="date-text">{trip.ChartDate}</div>
        </div>
      </div>
      <div className="options-list">
        {options.map((item, index) => (
          <Card
            key={item.label}
            label={item.label}
            icon={item.icon}
            activeStatus={selectedOption === index}
            onClick={() => handleOptionClick(index, item.path)}
          />
        ))}
      </div>
    </div>
  );
};

export default TripDetails;
